// Per-page registry of recorder-mode seek handlers. Each registered handler
// is a function `(timeSec: number) => Promise<void>` invoked by the visor's
// __SCENE_RECORDER_SEEK_FRAME bridge. Module-level Map so plugin instances
// and VisorApp share state without prop-drilling. Cleared between scenes
// by VisorApp's recorder cleanup path.

const handlers = new Map();

export function registerSeek(id, fn) {
  handlers.set(id, fn);
}

export function unregisterSeek(id) {
  handlers.delete(id);
}

export function clearRegistry() {
  handlers.clear();
}

export async function runAllSeeks(timeSec) {
  const fns = Array.from(handlers.values());
  await Promise.all(fns.map((fn) => fn(timeSec)));
}
